<template>
  <!-- Authors Table Card -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: '0 20px' }"
  >
    <div class="seareh_box">
      <a-form layout="inline">
        <a-form-item label="帐号">
          <a-input v-model="searchKey" placeholder="请输入帐号" />
        </a-form-item>

        <a-form-item label="帐号状态">
          <a-select style="width: 120px" v-model="auditStatus">
            <a-select-option
              v-for="(item, index) in statusList"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="创建时间">
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="time" />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="getUserPage"> 查询 </a-button>
          <a-button type="danger" style="margin-left: 10px" @click="addUser">
            创建帐号
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :pagination="pagination"
      :data-source="tableData"
      @change="tableChange"
    >
      <span slot="key" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="auditStatus" slot-scope="text, record">
        <a-tag v-if="record.auditStatus == 1" color="orange"> 未提审 </a-tag>
        <a-tag v-if="record.auditStatus == 2" color="blue"> 审核中 </a-tag>
        <a-tag v-if="record.auditStatus == 3" color="green"> 正常 </a-tag>
        <a-tag v-if="record.auditStatus == 4" color="red"> 审核不通过 </a-tag>
      </div>
      <span slot="action" slot-scope="text, record">
        <a
          @click="$refs.companyItem.open(record)"
          v-if="record.auditStatus == 1 || record.auditStatus == 4"
          >{{ record.auditStatus == 1 ? "上传资料" : "重新上传" }}</a
        >
        <a v-else @click="$refs.companyItem.open(record)">查看资料</a>
        |
        <a @click="$refs.devSettings.open(record)">开发设置</a>
      </span>
    </a-table>
    <a-modal
      v-model="visible"
      title="创建帐号"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
    >
      <a-form :form="form">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="帐号"
        >
          <a-input
            v-model="account"
            :maxLength="20"
            @input="validateInput"
            placeholder="请输入账号!"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="初始密码"
        >
          <div>123456</div>
        </a-form-item>
      </a-form>
    </a-modal>
    <company ref="companyItem" @getInfo="getInfo"></company>
    <devSettings ref="devSettings" @getInfo="getInfo"></devSettings>
  </a-card>
</template>

<script>
import { getUserPage, addUser } from "@/api/userList";
import company from "./commponents/company.vue";
import devSettings from "./commponents/devSettings.vue";
const table1Columns = [
  {
    title: "序号",
    dataIndex: "key",
    scopedSlots: { customRender: "key" },
  },
  {
    title: "帐号",
    dataIndex: "account",
    scopedSlots: { customRender: "account" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  //   {
  //     title: "昵称",
  //     dataIndex: "nickname",
  //     scopedSlots: { customRender: "nickname" },
  //   },
  //   {
  //     title: "身份证号",
  //     dataIndex: "idCardNumber",
  //   },
  {
    title: "余额",
    dataIndex: "balance",
  },

  {
    title: "帐号状态",
    dataIndex: "auditStatus",
    scopedSlots: { customRender: "auditStatus" },
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const formTailLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18, offset: 4 },
};
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  components: {
    company,
    devSettings,
  },
  data() {
    return {
      account: "",
      searchKey: "",
      auditStatus: "",
      confirmLoading: false,
      statusList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "未提审",
        },
        {
          value: "2",
          label: "审核中",
        },
        {
          value: "3",
          label: "正常",
        },
        {
          value: "4",
          label: "审核不通过",
        },
      ],
      visible: false,
      columns: table1Columns,
      tableData: [],
      time: [],
      pagination: {
        showQuickJumper: true,
        showSizeChanger: true,
        total: 3,
        pageSize: 10,
        current: 1,
      },
      // Active button for the "Authors" table's card header radio button group.
      hasErrors,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
    };
  },
  mounted() {
    this.pagination.current = 1;
    this.getUserPage();
  },
  methods: {
    getInfo() {
      this.pagination.current = 1;
      this.getUserPage();
    },
    getUserPage() {
      getUserPage({
        searchKey: this.searchKey,
        auditStatus: this.auditStatus,
        startCreateTime: this.time[0] || "",
        endCreateTime: this.time[1] || "",
        current: this.pagination.current,
        size: this.pagination.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.pagination.total = res.total;
      });
    },
    validateInput() {
      // 使用正则表达式匹配字母和数字
      const regex = /^[A-Za-z0-9]+$/;
      if (!regex.test(this.account)) {
        // 如果输入不符合要求，移除最后一个字符
        this.account = this.account.slice(0, -1);
      }
    },
    tableChange(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.getUserPage();
    },
    // Only show error after a field is touched.
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("userName") && getFieldError("userName");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
    // 打开增加用户的弹窗
    addUser() {
      this.visible = true;
      this.account = "";
      this.$nextTick(() => {
        // To disabled submit button at the beginning.
        this.form.resetFields();
      });
    },
    // 增加用户
    handleOk(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) {
          console.log("Received values of form: ", values);
          return;
        }
        if (this.account.length < 6 || this.account.length > 20) {
          this.$message.warning("请输入6到20位字母或数字组成的帐号");
          return;
        }

        let data = {
          account: this.account,
        };
        this.confirmLoading = true;
        addUser(data).then((res) => {
          this.confirmLoading = false;
          this.visible = false;
          this.$message.success("帐号创建成功");
          this.pagination.current = 1;
          this.getUserPage();
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.seareh_box {
  padding: 20px 10px;
}
.add_box {
  display: flex;
  // align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 10px;
}
</style>
